__turbopack_context__.v({
  "isHidden": "dzNx5G_isHidden",
  "isSmall": "dzNx5G_isSmall",
  "popup": "dzNx5G_popup",
});
